<p-card
	[header]="'presentation.app.page.profile.coach.biography.header' | translate"
	styleClass="h-52"
>
	<div class="h-full relative">
		<ng-scrollbar
			class="absolute w-full h-full top-0 left-0"
			track="vertical"
			visibility="hover"
		>
			<span [innerHTML]="biography | html" class="text-sm leading-4"></span>
		</ng-scrollbar>
	</div>
</p-card>
